import type { TransformFunctions } from '@sitecore/common';

export const appBannerAppId = '323620551';
export const appBannerAppArgument = 'https://app.oxxio.nl';

export const businessUnit = 'nl';
export const countryCode = 'NL';
export const label = 'oxxio';
export const name = 'nl-oxxio-main';
export const uuid = 'hL8c5M';
export const transformFunctions: TransformFunctions = {};

/** Scopes Sanity page lookups to this container's own pages. `SANITY_SITE` overrides it. */
export const sanitySite = 'site-oxxio-nl';